module.exports = __webpack_public_path__ + "img/76.9bb23cd4.jpg";